import { armorAPI, unauthApi } from '~/services/api';
import { JSONRegisterUser } from '~/types/RegisterUser';

function register(payload: JSONRegisterUser) {
  return unauthApi.request({
    url: 'register/',
    method: 'POST',
    headers: {},
    data: payload,
  });
}

function login(payload: { email: string; password: string }) {
  return unauthApi.request({
    url: 'login/',
    method: 'POST',
    headers: {},
    data: payload,
  });
}

function resetPassword(payload: { email: string }) {
  return unauthApi.request({
    url: 'resetPassword/',
    method: 'POST',
    headers: {},
    data: payload,
  });
}

function resendVerification() {
  return armorAPI.request({
    url: '/verify/resend/',
    method: 'GET',
  });
}

export interface QuestionnairePayload {
  company_name: string | null;
  phone: string | null;
  monthly_packages: string | number | boolean | null;
  primary_carrier: string | null;
  primary_ecommerce_channel: string | null;
  is_unsupported_store: boolean;
}

function sendQuestionnaire(payload: QuestionnairePayload, temporatyToken: string) {
  return armorAPI.request({
    url: 'setting/registration-info',
    method: 'POST',
    headers: {
      Authorization: `JWT ${temporatyToken}`,
    },
    data: payload,
  });
}

export { register, login, resetPassword, resendVerification, sendQuestionnaire };
